




























import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import PropertyData from '@/ts/PropertyData';

@Component
export default class AddConversationDialog extends Mixins(DeviceMethods) {
    public searchQuery: string = '';
    public suggestionsReady: boolean = false;
    public currentlyHovered: number | null = null;
    public visible: boolean = false;

    constructor() {
        super();
    }

    get resultList() {
        if (this.searchQuery === '') {
            return this.$store.state.Properties.properties;
        }

        if (this.$store.getters['vuexSearch/@@vuexSearch/getter/isSearching']('properties') === true) {
            return [];
        }

        const searchResult = this.$store.getters['vuexSearch/@@vuexSearch/getter/result']('properties');

        return this.$store.state.Properties.properties.filter((property: PropertyData) => {
            return searchResult.includes(property.id);
        });
    }

    get query(): string {
        return this.searchQuery;
    }

    set query(value: string) {
        this.searchQuery = value;
        this.$store.search.search('properties', this.searchQuery);
    }

    public createConversation(propertyId: number): void {
        this.$store.dispatch(Actions.INITIALIZE_PROPERTY_CONVERSATION, propertyId);
        this.$store.commit(Mutations.SET_ADD_CONVERSATION_DIALOG_VISIBILITY, false);
    }

    get dataLoaded(): boolean {
        return (
            this.$store.getters['Messages/activeConversation'] !== null
         && this.$store.getters['Messages/currentParticipants']
        );
    }

    get addConversationDialogVisible(): boolean {
        return this.$store.state.Messages.addConversationDialogVisible;
    }

    public close() {
        return this.$store.commit(Mutations.SET_ADD_CONVERSATION_DIALOG_VISIBILITY, false);
    }
}
